import compact from "lodash/compact";
import join from "lodash/join";

const combineStrings = (arr: string[], delimiter = "-"): string => {
  return join(compact(arr), delimiter);
};

export default combineStrings;
